module.exports = __webpack_public_path__ + "img/Artzie.69d88218.png";